module.exports = __webpack_public_path__ + "img/4_etablissement_rouge.13629bda.svg";